import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { string } from "zod";

interface SceneCardInformationState {
  linkedStatus: boolean | undefined;
  showPage?: boolean;
  isLoading?: boolean;
  isVerified?: boolean;
  cardStatus?: string;
  cardInfo: {
    data: {
      pointBalance: number;
      dollarValue: number;
    };
  } | null;
  scene?: {
    cardNumber: string;
    linkedStatus: boolean;
  } | null;
}

const initialState: SceneCardInformationState = {
  scene: null,
  showPage: true,
  isVerified: false,
  cardInfo: null,
  cardStatus: "",
  linkedStatus: undefined,
  isLoading: false,
};

const SceneCardInfoSlice = createSlice({
  name: "SceneCardInfo",
  initialState,
  reducers: {
    setSceneCardInfo: (
      state,
      action: PayloadAction<SceneCardInformationState>
    ) => {
      state.scene = action.payload?.scene;
      state.showPage = action.payload.showPage;
      state.isVerified = action.payload.isVerified;
      state.cardStatus = action.payload.cardStatus;
      state.cardInfo = action.payload.cardInfo;
      state.isLoading = false;
    },
  },
});

export const { setSceneCardInfo } = SceneCardInfoSlice.actions;

export default SceneCardInfoSlice.reducer;
